import { BalanceCalculationService } from "./BalanceCalculationService";
import { DeltaCalculationService } from "./DeltaCalculationService";
import { GammaCalculationService } from "./GammaCalculationService";
import { ThetaCalculationService } from "./ThetaCalculationService";
import { VegaCalculationService } from "./VegaCalculationService";
import { RhoCalculationService } from "./RhoCalculationService";

class PortfolioCalculationService {
    readonly balance: BalanceCalculationService;
    readonly delta: DeltaCalculationService;
    readonly gamma: GammaCalculationService;
    readonly vega: VegaCalculationService;
    readonly theta: ThetaCalculationService;
    readonly rho: RhoCalculationService;

    constructor() {
        this.balance = new BalanceCalculationService();
        this.delta = new DeltaCalculationService();
        this.gamma = new GammaCalculationService();
        this.vega = new VegaCalculationService();
        this.theta = new ThetaCalculationService();
        this.rho = new RhoCalculationService();
    }
}

export const portfolioCalculationService = new PortfolioCalculationService();